import React, {useState} from 'react'
import {useHistory, useLocation} from "react-router-dom";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {updateCompanyInfoPublicService, updateProgramInfoPublicService} from "../../services/rating_public.service";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";
import CPCCompanyProgramInfoView from "../../views/ver_24.10/ProgramRating/CPCStarsRating/CPCCompanyProgramInfo.view";

const CompanyProgramInfoMainPage = () => {
    const history = useHistory();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const currentStatus = location.state?.currentStatus || 'ORGANIZATION_INFO';

    const company_data = {
        defaultInitialValues : {
            NameOrg: "Test Organization",
            Region: "Singapore",
        },

        emptyInitialValues : {
            NameOrg: "",
            Region: "",
        },
    };
    const program_data = {
        defaultInitialValues : {
            ProgramName: 'Sample Program',
            ProgramAims: 'Sample aims and objectives',
            ProgramTarget: 'Workforce',
            ProgramTargetOther:'Sample Program Target',
            ProgramTargetMinAge:'20',
            ProgramTargetMaxAge:'40',
            TargetAge: '',
            TargetCountry: 'Singapore',
            Devices:'Smartphone',
            DeviceTypeOther:'',
            ProgramVenue: 'Schools',
            ProgramVenueOther:'',
            ProgramDuration: 'lessthan15min',
            OtherDurationHours:'',
            ResourcesType:'Research',
            ResourcesTypeOther:'',
            ResourcesFormat:'Podcast',
            ResourcesFormatOther: '',
            RefResource: 'Sample resources',
            StartYear: '2023',
            UpdateYear:'2023',
            Status: 'Active',
            Links: 'http://example.com',
            ProgramPrice: 'free',
            Success: 'Sample success definition',
            SuccessMeasure: 'Sample success measure',
            KPITrack: 'Sample KPI tracking',
            RefFramework: 'no',
            RefAlignment:'Framework Alignment',
        },

        emptyInitialValues : {
            Devices: '',
            DeviceTypeOther:'',
            ProgramName: '',
            ProgramAims: '',
            ProgramTarget: '',
            ProgramTargetOther:'',
            ProgramTargetMinAge:'',
            ProgramTargetMaxAge:'',
            TargetAge: '',
            TargetCountry: '',
            ProgramVenue: '',
            ProgramVenueOther:'',
            ProgramDuration: '',
            OtherDurationHours:'',
            ResourcesType:'',
            ResourcesTypeOther:'',
            ResourcesFormat:'',
            ResourcesFormatOther:'',
            RefResource: '',
            StartYear: '',
            UpdateYear:'',
            Status: '',
            Links: '',
            ProgramPrice: '',
            Success: '',
            SuccessMeasure: '',
            KPITrack: '',
            RefFramework: '',
            RefAlignment:''
        },
    };
    const data = {
        company_data,
        program_data,
        currentStatus
    }
    const company_actions = {

    };

    const program_actions = {
        submitAction : (values) => {
            setShowLoader(true);
            setTimeout(async () => {
                setShowLoader(false);
                const fingerprint_id = localStorage.getItem(LOCAL_STORAGE_KEYS.user_rating_fingerprint);
                debugger;
                const response1 = await updateCompanyInfoPublicService(fingerprint_id, values);
                if (response1 && !response1.error) {
                    console.log("Company Info Updated");
                    const response = await updateProgramInfoPublicService(fingerprint_id, values);
                    if (response.data && response.data.program_application && response.data.program_info) {
                        console.log("Successfully updated program application: ", response.data.program_application);
                        console.log("Successfully updated program info: ", response.data.program_info);
                        history.push({
                            pathname: '/rating/program',
                            state: { currentStatus: 'PROGRAM_INFO' }
                        });
                    }
                }

            }, 2000);
        },

    };

    const actions = {
        company_actions,
        program_actions,
    }
    const company_options = {

    };

    const program_options = {

    };

    const options = {
        company_options,
        program_options
    }

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <CPCCompanyProgramInfoView data={data} actions={actions} options={options} />
        </>
    );
};

export default CompanyProgramInfoMainPage;